import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DisplayUserEmail } from '@nusign/picflow-backend-types';
import { StateService } from '../../../services/state.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-gallery-owner-access-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemBodyComponent,
    AccessItemCtaComponent,
    ButtonDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-owner-access-item.component.html',
  styleUrl: './gallery-owner-access-item.component.scss',
})
export class GalleryOwnerAccessItemComponent {
  private state = inject(StateService);
  owner = input.required<DisplayUserEmail>();

  isMe = computed(() => {
    const owner = this.owner();
    if (!owner) return;
    return owner.id === this.state.user.id;
  });
}
